<template>
  <master-crud-page
    master="notification/contact"
    title="Notification Contact"
    access="master_notification_contact"
    pk="ntcnId"
    :columns="columns"
    :fields="fields"
    :filters="filters"
    :embedded="embedded"
    page-size-selectable
    forbidden-text="This module is internal only."
  />
</template>

<script>
import MasterCrudPage from '@/components/master/MasterCrudPage';
import { STATUS_OPTIONS, statusColumn } from '@/util/notificationConfig';

export default {
  name: 'MasterNotificationContact',
  components: { MasterCrudPage },
  props: {
    embedded: { type: Boolean, default: false },
  },
  data() {
    return {
      columns: [
        { key: 'ntcnName', label: 'Name', align: 'left' },
        { key: 'ntcnEmail', label: 'Email', align: 'left' },
        { key: 'ntcnPhone', label: 'Phone' },
        {
          key: 'ntcnCompId',
          label: 'Scope',
          formatter: (value) => (Number(value) === 0 ? 'Internal' : 'Company'),
        },
        statusColumn('ntcnStatus', 'Status'),
      ],
      fields: [
        {
          key: 'ntcnName', label: 'Name', type: 'text', required: true,
        },
        {
          key: 'ntcnEmail', label: 'Email', type: 'text', required: true,
        },
        { key: 'ntcnPhone', label: 'Phone', type: 'text' },
        {
          key: 'ntcnStatus', label: 'Status', type: 'select', options: STATUS_OPTIONS, default: 1,
        },
        {
          key: 'ntcnCompId',
          label: 'Scope',
          type: 'select',
          options: [{ value: '', text: 'Active company' }, { value: 0, text: 'Internal mailbox' }],
          default: '',
          hint: 'Internal mailbox is only allowed for internal accounts.',
        },
      ],
      filters: [
        {
          key: 'ntcnStatus', label: 'Status', type: 'select', options: STATUS_OPTIONS, colMd: 3,
        },
        { key: 'ntcnName', label: 'Search name', colMd: 3 },
      ],
    };
  },
};
</script>
